export default __webpack_public_path__ + "static/media/general.0d9b39e0.svg";